import { Row, Col, Form, Checkbox, Input, Space, Badge, Radio } from "antd";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_answer_call_form } from "../../actions/search_slice";
import { debounce } from "lodash";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";

const AnswerCall = forwardRef(
  (
    { onValuesChange, callbackNumber, agentName, callAnswered, caseName },
    ref
  ) => {
    const [form] = Form.useForm();
    const [value, setValue] = useState("");

    useImperativeHandle(ref, () => ({
      getFieldsError: form.getFieldsError,
      validateFields: form.validateFields,
      resetFields: form.resetFields,
      setFieldsValue: form.setFieldsValue,
      scrollToField: form.scrollToField,
      submit: form.submit,
      getFieldsValue: form.getFieldsValue,
      getFieldValue: form.getFieldValue,
      setFieldValue: form.setFieldValue,
    }));

    const dispatch = useDispatch();
    const formData = useSelector((state) => state.search.answer_call_form_type);

    const handleFormChange = debounce((changedValues) => {
      dispatch(update_answer_call_form(changedValues));
      onValuesChange(formData);
    }, 300);

    const onChangeRadio = ({ target: { value } }) => {
      console.log("radio checked", value);
      setValue(value);
    };

    // useEffect(() => {
    //   console.log("[AnswerCall][useEffect]", form);
    // }, [form]);

    return (
      <Form
        form={form}
        style={{ color: "black" }}
        initialValues={{
          "Agent Name": agentName,
          "Client Name": caseName,
          "Do you have time to complete the entire interview process today?":
            null,
        }}
        onValuesChange={handleFormChange}
        labelAlign="justify"
        layout="vertical"
        labelWrap
        wrapperCol={{
          flex: 1,
        }}
      >
        <Row gutter={[2, 2]}>
          <Col span={4}>Start Time</Col>
          <Col span={20}>{callAnswered}</Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>ANSWER CALL:</Row>
        <Row>
          <Row>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="Thank you for calling the Kansas Department for Children and
              Families. My Name is:"
              />
            </Space>
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              <Form.Item
                // name="agent_name"
                name="Agent Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input

                // id="agent_name"
                // value={agentName}
                // onChange={onChangeName}
                // placeholder={agentName || "Enter Agent Name"}
                />
              </Form.Item>
            </Space>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="Can I please get your name and a good call back number in case
              we get disconnected?"
              />
            </Space>
            {/* <Space direction="vertical">
            <Badge color="#0d0b0b" text="Client Call back Number:" />
          </Space> */}
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              <Row gutter={2}>
                <Col span={12}>
                  <Form.Item
                    // name="clientName"
                    name="Client Name"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      // id="Client Name"
                      placeholder="Enter Client Name"
                      // value={caseName}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    // name="callbackNum"
                    name="Callback Number"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      id="callbackNum"
                      value={callbackNumber}
                      // onChange={onChangeCallbackNumber}
                      placeholder={callbackNumber || "Enter Callback Number"}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Space>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="If our call is disconnected, at any point, I will call you back
              at the number you have provided. Please do not attempt to call the
              main number again as that will place you back in the queue and you
              will need to start your wait time and interview over."
              />
            </Space>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="Completing an interview is required for both the Food Assistance
              and TANF programs."
              />
            </Space>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="At the end of your interview I will inform you of your
              eligibility determination or what information is still needed to
              make a determination."
              />
            </Space>
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="The typical interview takes around (your average time to
              complete interview)."
              />
            </Space>
          </Row>
        </Row>
        <Form.Item
          name="Do you have time to complete the entire interview process today?"
          // name="selectedOption"
          label={
            <Space direction="vertical">
              <Badge
                color="#0d0b0b"
                text="Do you have time to complete the entire interview process today?"
              />
            </Space>
          }
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Radio.Group
            // style={{ fontSize: "14px", height: "25px", width: "25px" }}
            value={value}
            options={[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ]}
            onChange={onChangeRadio}
          />
        </Form.Item>

        <Row style={{ marginTop: "10px" }}> TASK/Flags:</Row>
        <Form.Item
          // name="taskFlags"
          name="Task Flags"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Checkbox.Group
            style={{
              width: "100%",
              marginTop: "10px",
            }}
            //   onChange={onChange}
          >
            {/* <Row>
            <Col span={12}> */}
            <Checkbox value="Claim All KEES Tasks (Do not claim WP task)">
              Claim All KEES Tasks (Do not claim WP task)
            </Checkbox>
            {/* </Col>
            <Col span={12}> */}
            <Checkbox value="Claim case from EES Tracker">
              Claim case from EES Tracker
            </Checkbox>
            {/* </Col>
          </Row>
          <Row>
            <Col span={12}> */}
            <Checkbox value="Review Case Flags">Review Case Flags</Checkbox>
            {/* </Col>
            <Col span={12}> */}
            <Checkbox value="Review KEES Journal">Review KEES Journal</Checkbox>
            {/* </Col>
          </Row> */}
          </Checkbox.Group>
        </Form.Item>

        <Row gutter={[2, 2]}>
          <Col span={4}>Perceptive Content</Col>
          <Col span={20}>
            Check OneNote / Perceptive Content for verification(s) provided
          </Col>
        </Row>
        <Row gutter={[2, 2]} style={{ marginTop: "5px" }}>
          <Col span={4}>Application</Col>
          <Col span={20}>
            <Row>
              Check to make sure the application is complete (Signature, Date,
              and Address). If relevant questions are not answered, the missing
              information can be obtained during the interview. If on the phone
              ensure the application has been signed, if not conduct the
              Telephonic Signature process.
            </Row>
            <Row>
              ***Check All Program Blocks for requested programs and HH
              members***
            </Row>
          </Col>
        </Row>
      </Form>
    );
  }
);
export default AnswerCall;
